<template>
  <div class="ecm__cart-items__container-item">
    <DeleteDialog ref="deleteDialogRef" @handleDeleteItem="handleDeleteItem"/>
    <div class="ecm__cart-items__container-item__check">
      <Checkbox
        v-model="isSelected"
      />
    </div>
    <div class="ecm__cart-items__container-item__cover">
      <img :src="item.Book.cover" alt="">
    </div>
    <div class="ecm__cart-items__container-item__desc">
      <div class="ecm__cart-items__container-item__desc-item">
        <p class="value">{{ item.Book.title }}</p>
      </div>
      <div class="ecm__cart-items__container-item__desc-item">
        <p class="value price-color">Rp {{ formatPrice(item.Book.price) }}</p>
      </div>
      <div class="ecm__cart-items__container-item__quantity">
        <div class="ecm__cart-items__container-item__quantity-counter">
          <button class="plus" @click="handleAddQuantity(item.Book.id)">+</button>
          <div class="count">
            <p>{{ quantity }}</p>
          </div>
          <button class="minus" @click="handleMinusQuantity(item.Book.id)">-</button>
        </div>
      </div>
    </div>
    <div class="ecm__cart-items__container-item__quantity">
      <div class="ecm__cart-items__container-item__quantity-counter">
        <button class="plus" @click="handleAddQuantity(item.Book.id)">+</button>
        <div class="count">
          <p>{{ quantity }} / {{ item.Book.stock }}</p>
        </div>
        <button class="minus" @click="handleMinusQuantity(item.Book.id)">-</button>
      </div>
    </div>
    <div class="ecm__cart-items__container-item__price">
      Rp {{ formatPrice(item.Book.price * quantity) }}
    </div>
    <div class="ecm__cart-items__container-item__remove">
      <i @click="handleShowDeleteDialog" class="fas fa-times-circle"></i>
    </div>
  </div>
</template>

<script>
import formatDisplay from '@/mixins/formatDisplay.js'
import Checkbox from '@/components/inputs/Checkbox'
import DeleteDialog from '@/components/modals/DeleteItem'
import { mapActions } from 'vuex'

export default {
  name: 'Cart_Card',
  mixins: [formatDisplay],
  components: {
    Checkbox,
    DeleteDialog
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      outerVisible: true
    }
  },
  computed: {
    quantity: {
      get () {
        return this.$props.item.quantity
      },
      set (payload) {
        this.$props.item.quantity = payload
      }
    },
    isSelected: {
      get () {
        return this.$props.item.is_selected
      },
      set (payload) {
        this.$props.item.is_selected = payload
        this.handleCheckedItem(payload)
      }
    }
  },
  methods: {
    ...mapActions({
      fetchCarts: 'cart/fetchCarts',
      incrementQuantity: 'cart/incrementQuantity',
      decrementQuantity: 'cart/decrementQuantity',
      deteleItem: 'cart/deteleItem',
      checkedItem: 'cart/checkedItem'
    }),
    async handleCheckedItem (isChecked) {
      try {
        const resp = await this.checkedItem({ bookId: this.$props.item.Book.id })
        if (resp.msg === 'selected has been updated') {
          this.$emit('handleCheckItem', {
            cartItem: this.$props.item,
            isCheckedItem: isChecked
          })
        }
      } catch (error) {
        this.$emit('handleFetchCarts')
        if (error?.response?.data?.msg === "data not found") {
          this.$message({
            showClose: false,
            message: "This book is no longer available",
            type: 'error',
          })
        } else if (error?.response?.data?.msg === "there are no items in your cart") {
          this.$message({
            showClose: false,
            message: "there are no items in your cart",
            type: 'error',
          })
        }
      }
    },
    async handleAddQuantity (bookId) {
      if (this.$props.item.Book.stock > this.quantity) {
        try {
          const resp = await this.incrementQuantity({ bookId })
          if (resp.data.quantity > this.quantity) {
            this.quantity++
            this.$emit('handleAddQuantity', {
              cartId: this.$props.item.id,
              quantity: this.quantity
            })
          }
        } catch (error) {
          this.$emit('handleFetchCarts')
          if (error?.response?.data?.msg === "data not found") {
            this.$message({
              showClose: false,
              message: "This book is no longer available",
              type: 'error',
            })
          } else if (error?.response?.data?.msg === "can't exceed stock limit") {
            this.$message({
              showClose: false,
              message: "can't exceed stock limit",
              type: 'error',
            })
          }
        }
      }
    },
    async handleMinusQuantity (bookId) {
      if (this.quantity > 1) {
        try {
          await this.decrementQuantity({ bookId })
          if (this.quantity > 0) {
            this.quantity--
            this.$emit('handleMinusQuantity', {
              cartId: this.$props.item.id,
              quantity: this.quantity
            })
          }
        } catch (error) {
          this.$emit('handleFetchCarts')
          if (error?.response?.data?.msg === "data not found") {
            this.$message({
              showClose: false,
              message: "This book is no longer available",
              type: 'error',
            })
          } else if (error?.response?.data?.msg === "cannot be less than 0") {
            this.$message({
              showClose: false,
              message: "cannot be less than 0",
              type: 'error',
            })
          }
        }
      }
    },
    handleShowDeleteDialog () {
      this.$refs.deleteDialogRef.setIsShow(true)
    },
    async handleDeleteItem () {
      try {
        const resp = await this.deteleItem({ bookId: this.$props.item.Book.id })
        if (resp.msg === 'successfully delete item') {
          this.$emit('handleFetchCarts')
        }
      } catch (error) {
        this.$emit('handleFetchCarts')
        if (error?.response?.data?.msg === "data not found") {
          this.$message({
            showClose: false,
            message: "This book is no longer available",
            type: 'error',
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__cart-items__container-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.213);
  height: 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
  .ecm__cart-items__container-item__check {
    padding: 0 5px;
  }
  .ecm__cart-items__container-item__cover {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-width: 60px;
    overflow: hidden;
    img {
      height: 100%;
    }
  }
  .ecm__cart-items__container-item__desc,
  .ecm__cart-items__container-item__quantity,
  .ecm__cart-items__container-item__price,
  .ecm__cart-items__container-item__remove {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 70px;
    font-size: 13.5px;
    word-wrap: break-word;
  }
  .ecm__cart-items__container-item__desc {
    font-weight: 500;
    width: 390px;
    .ecm__cart-items__container-item__desc-item {
      display: flex;
      justify-content: flex-start;
      padding-left: 7px;
      line-height: 1.3;
      .value {
        font-size: 15px;
        width: 100%;
        &.price-color {
          color: var(--color-pink);
        }
      }
      &:first-child {
        margin-bottom: 5px;
      }
    }
    .ecm__cart-items__container-item__quantity {
      display: none;
    }
  }
  .ecm__cart-items__container-item__quantity {
    margin: 0 7px;
    align-items: center;
    width: 150px;
    flex-direction: row;
    .ecm__cart-items__container-item__quantity-counter {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      border-radius: 22px;
      font-weight: 500;
      cursor: default;
      .count {
        min-width: 50px;
        margin: 0 5px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .plus, .minus {
        cursor: pointer;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        outline: none;
        border: none;
        font-weight: 500;
        font-size: 15px;
        color: white;
        background: var(--color-blue-background);
      }
    }
  }
  .ecm__cart-items__container-item__price {
    width: 180px;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
  }
  .ecm__cart-items__container-item__remove {
    flex: 1;
    text-align: end;
    color: rgb(255, 0, 0);
    .fa-times-circle {
      font-size: 15px;
      cursor: pointer;
    }
  }
}
</style>
